import React from 'react';
import { DatePicker as MDatePicker } from '@material-ui/pickers';
import { Moment } from 'moment';
import CalendarIcon from '@material-ui/icons/Event';
import { InputAdornment, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  dateField: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
  },
});

export type DatePickerProps = {
  value: Date | Moment | undefined | null;
  onChange: (date: Moment | null, value?: string | null) => void;
  minDate?: Moment | undefined | Date | null;
  minDateMessage?: string | JSX.Element;
  maxDate?: Moment | undefined | Date | null;
  maxDateMessage?: string | JSX.Element;
  disableFuture?: boolean;
  disablePast?: boolean;
  dense?: boolean;
  label: JSX.Element | string;
  shouldDisableDate?: (i: Moment | null) => boolean;
};

export const DatePicker = (props: DatePickerProps) => {
  const classes = useStyles();
  const { dense, ...rest } = props;
  return (
    <MDatePicker
      {...rest}
      inputVariant="outlined"
      autoOk
      value={props.value}
      onChange={props.onChange}
      format={'YYYY-MM-DD [UTC]'}
      className={classes.dateField}
      InputProps={{
        margin: dense ? 'dense' : undefined,
        startAdornment: (
          <InputAdornment position="start">
            <CalendarIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
